// teamSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  teamData: null,
};

const teamSlice = createSlice({
  name: "team",
  initialState,
  reducers: {
    setTeamData(state, action) {
      state.teamData = action.payload;
    },
  },
});

// Export actions
export const { setTeamData } = teamSlice.actions;

// Export reducer
export default teamSlice.reducer;
